import type { IframeUnopenedOffer } from '../../../modules/api';
import { UnopenedPackCard } from '../cards/UnopenedPackCard';
import { EmptyState } from '../EmptyState';

export interface RepackzTabProps {
  offers: IframeUnopenedOffer[];
  loading: boolean;
  onOpen: (offer: IframeUnopenedOffer) => void;
  onBrowse: () => void;
}

export function RepackzTab({ offers, loading, onOpen, onBrowse }: RepackzTabProps) {
  if (loading && offers.length === 0) {
    return (
      <div className="grid grid-cols-1 gap-4 @[600px]:grid-cols-2 @[900px]:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="
              aspect-[485/311] rounded-[28px] animate-pulse
              border-2 border-[rgba(171,174,179,0.24)]
              bg-white/5
            "
          />
        ))}
      </div>
    );
  }

  if (offers.length === 0) {
    return (
      <EmptyState
        title="No Repackz Found"
        cta="Buy Repackz"
        onAction={onBrowse}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 @[600px]:grid-cols-2 @[900px]:grid-cols-3">
      {offers.map((offer) => (
        <UnopenedPackCard key={offer.id} offer={offer} onOpen={onOpen} />
      ))}
    </div>
  );
}
